// extracted by mini-css-extract-plugin
export default {"dragHandle":"styles-module__dragHandle__src-labstep-web-core-Sortable-Item-DragHandle-_d3IIz","icon":"styles-module__icon__src-labstep-web-core-Sortable-Item-DragHandle-_NAWVy"};